import { Add } from "@mui/icons-material";
import { Box, Button, Stack } from "@mui/material";
import {
  ColumnVisibilityFilter,
  SearchFilter,
  SectionHeader,
} from "@shared/components";
import { FormActions } from "@shared/utils/constant";
import { useState } from "react";
import { ColumnOptions } from "../utils/constants";
import {
  ColumnKey,
  FilterField,
  PartnerChannelsFormValues,
  PartnerChannelsHeaderProps,
} from "../utils/types";
import PartnerChannelForm from "./partnerChannelForm";
import { FormikHelpers } from "formik";
import { enqueueSnackbar } from "notistack";
import { UseCreateNewPartnerChannel } from "../services/useCreateNewPartnerChannel";
import { Can } from "@core/casl-provider";

const filterFields: FilterField[] = [
  {
    id: "partners-channels-search",
    name: "searchQuery",
    label: "Search Partner Channels",
    placeholder: "Search partner channels...",
    clearAriaLabel: "clear partner channels search",
  },
];

const PartnerChannelsHeader = ({
  visibleColumns,
  setVisibleColumns,
}: PartnerChannelsHeaderProps) => {
  const [actionState, setActionState] = useState<{
    action: FormActions.ADD | "";
    payload: PartnerChannelsFormValues | object;
  }>({
    action: "",
    payload: {} as PartnerChannelsFormValues,
  });

  const { mutateAsync: createPartnerChannelAsync, isPending } =
    UseCreateNewPartnerChannel();

  const clearActionState = () => {
    setActionState({ action: "", payload: {} });
  };

  const handleSubmit = async (
    values: PartnerChannelsFormValues,
    helpers: FormikHelpers<PartnerChannelsFormValues & { id?: number }>
  ) => {
    try {
      await createPartnerChannelAsync({ payload: values });
      clearActionState();
    } catch (error) {
      const errMsg = (error as Error)?.message || "Something went wrong";
      enqueueSnackbar(errMsg, {
        variant: "error",
        autoHideDuration: 5000,
      });
    } finally {
      helpers.setSubmitting(false);
    }
  };
  return (
    <>
      <Box>
        <SectionHeader title="Partner Channels" />
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          mt={3}
          alignItems="center"
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderBottom: 0,
            backgroundColor: "background.paper",
            padding: "15px",
            borderRadius: "4px 4px 0 0",
          })}
        >
          <SearchFilter filterFields={filterFields} />

          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
          >
            <ColumnVisibilityFilter
              value={visibleColumns as string[]}
              onChange={(vals) => setVisibleColumns(vals as ColumnKey[])}
              options={ColumnOptions}
              size="medium"
            />

            <Can
              do={"create"}
              on={"PartnerChannel"}
            >
              <Button
                variant="contained"
                sx={{ height: 38, padding: "0 20px" }}
                onClick={() =>
                  setActionState({ action: FormActions.ADD, payload: {} })
                }
                startIcon={<Add />}
              >
                Add New Partner channel
              </Button>
            </Can>
          </Stack>
        </Stack>
      </Box>

      <PartnerChannelForm
        open={actionState.action === FormActions.ADD}
        onClose={clearActionState}
        title="Add Partner Channel"
        initialValues={actionState.payload}
        disable={isPending}
        onSubmit={handleSubmit}
        showCloseButton
      />
    </>
  );
};

export default PartnerChannelsHeader;
